import BaseParser from './BaseParser';
import _get from 'lodash/get';
import FhirDateTime from './FhirDateTime';
import { BaseParserOptions, PeriodOptions } from './SharedTypes';

class Period extends BaseParser {
  private fhirDateTimeParser: FhirDateTime;
  /**
   * @param {FhirDateTime} options.period.fhirDateTimeParser - The parser to use for start and end dateTime values
   */
  constructor(options: BaseParserOptions = {}) {
    super();

    const periodOptions = _get<BaseParserOptions, 'period', PeriodOptions>(
      options,
      'period',
      {},
    );
    this.fhirDateTimeParser = _get<
      PeriodOptions,
      'fhirDateTimeParser',
      FhirDateTime
    >(periodOptions, 'fhirDateTimeParser', new FhirDateTime());
  }

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getDisplayValue(fhirProperty: fhir.Period) {
    if (!fhirProperty) return null;

    const start = _get<fhir.Period, 'start', string>(
      fhirProperty,
      'start',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    const end = _get<fhir.Period, 'end', string>(fhirProperty, 'end', null);

    const startDisplayValue =
      this.fhirDateTimeParser.getDisplayValue(start) || 'N/A';
    const endDisplayValue =
      this.fhirDateTimeParser.getDisplayValue(end) || 'N/A';

    return `${startDisplayValue} - ${endDisplayValue}`;
  }

  /**
   * Sorts by start date time.  If start date time doesn't exist, it will sort by end date time
   */
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getSortValue(fhirProperty: fhir.Period) {
    if (!fhirProperty) return null;

    const start = _get<fhir.Period, 'start'>(fhirProperty, 'start');
    const end = _get<fhir.Period, 'end'>(fhirProperty, 'end');

    if (start !== undefined) {
      return this.fhirDateTimeParser.getSortValue(start);
    } else if (end !== undefined) {
      return this.fhirDateTimeParser.getSortValue(end);
    }

    return null;
  }
}

export default Period;
